import { AccountDeletionRequest } from '@wtf/shared'
import { Button } from '@/components/shared/atoms/Button'
import { useCancelAccountDeletion } from '@/hooks/api/useUsers'
import { useToast } from '@/components/shared/toast/Toast'

export const PendingDeletionBanner = ({
    deletionRequest,
    userId,
}: {
    deletionRequest: AccountDeletionRequest
    userId: string
}) => {
    const cancelDeletionMutation = useCancelAccountDeletion()
    const { addToast } = useToast()

    const handleCancel = async () => {
        try {
            await cancelDeletionMutation.mutateAsync(userId)
            addToast('Account deletion cancelled successfully', 'success')
        } catch (error) {
            console.error('Error cancelling deletion:', error)
            addToast('Failed to cancel deletion. Please try again.', 'error')
        }
    }

    const scheduledDate = new Date(
        deletionRequest.scheduledFor
    ).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    })

    return (
        <div className="rounded-xl border-2 border-yellow-500 bg-yellow-50 p-4">
            <div className="flex items-start gap-3">
                <svg
                    className="mt-0.5 h-6 w-6 flex-shrink-0 text-yellow-600"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                >
                    <path
                        fillRule="evenodd"
                        d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                        clipRule="evenodd"
                    />
                </svg>
                <div className="flex-1">
                    <h4 className="mb-1 text-sm font-semibold text-yellow-800">
                        Account Deletion Scheduled
                    </h4>
                    <p className="mb-3 text-sm text-yellow-800">
                        Your account is scheduled for deletion on{' '}
                        <span className="font-medium">{scheduledDate}</span>.
                        You can cancel this request at any time before then.
                    </p>
                    <Button
                        onClick={handleCancel}
                        disabled={cancelDeletionMutation.isPending}
                        className="rounded-lg bg-yellow-600 px-4 py-2 text-sm font-medium text-white transition hover:bg-yellow-700"
                    >
                        {cancelDeletionMutation.isPending
                            ? 'Cancelling...'
                            : 'Cancel Deletion'}
                    </Button>
                </div>
            </div>
        </div>
    )
}
